import bankAccConstants from "../constants/bankAccConstants";

const initialState: {
  newBankAcc: any;
  bankDetails: any;
} = {
  newBankAcc: null,
  bankDetails: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case bankAccConstants.ADD_BANK_ACC_SUCCESS:
    case bankAccConstants.EDIT_BANK_ACC_SUCCESS:
      return {
        ...state,
        newBankAcc: action.payload,
      };
    case bankAccConstants.GET_BANK_ACC_SUCCESS:
      return {
        ...state,
        bankDetails: action.payload.data.results[0],
      };
    default:
      return {
        ...state,
      };
  }
};
